import { Dispatch, SetStateAction } from "react";
import { omitBy, isNil } from "lodash";

import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";

import { IEntityModel, ITaskEventTracker } from "../../shared/db";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_ADD_TASK_EVENT_TRACKER } from "../state";
import { getToken } from "./token_fetcher";
import { Subtract } from "utility-types";
import { getTaskEventTrackerSchemaMap } from "../../model/event_tracker";

export const REQUEST_TASK_EVENT_TRACKER_CREATE = "REQUEST_TASK_EVENT_TRACKER_CREATE";
export const doREQUEST_TASK_EVENT_TRACKER_CREATE = createDoRequestAction(
  REQUEST_TASK_EVENT_TRACKER_CREATE,
);

export const requestTaskEventTrackerCreateActionCreators = {
  doREQUEST_TASK_EVENT_TRACKER_CREATE,
};

interface Payload {
  payload: {
    requestId: string;
    eventTracker: Subtract<Omit<ITaskEventTracker, "inactive">, IEntityModel>;
  };
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>;
}

export function* requestTaskEventTrackerCreate({
  payload,
  setRequestResult,
}: Payload): SagaIterator {
  debug("saga*requestTaskEventTrackerCreate");

  payload.eventTracker = omitBy(payload.eventTracker, isNil) as Payload["payload"]["eventTracker"];

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        eventTracker: v.object(getTaskEventTrackerSchemaMap({ required: ["taskId"] })),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_EVENT_TRACKER_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const accessToken = yield call(getToken);

  const { eventTracker } = payload;

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/task-event-tracker-create`,
    accessToken,
    data: eventTracker,
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_EVENT_TRACKER_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/task-event-tracker-create",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doMETHOD_ADD_TASK_EVENT_TRACKER(result.payload));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_EVENT_TRACKER_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* taskEventTrackerCreateSaga() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  yield takeEvery(REQUEST_TASK_EVENT_TRACKER_CREATE as any, requestTaskEventTrackerCreate);
}
